import React from "react";
import { Info } from "lucide-react";
import { useCruise } from "@/context/CruiseContext";

// Shown inside the workspace whenever the selected voyage is the onboarding sample.
export const SampleVoyageBanner = () => {
  const { voyage } = useCruise();
  if (!voyage?.is_demo) return null;
  return (
    <div
      role="note"
      data-testid="cc-sample-voyage-banner"
      className="mb-4 flex items-start gap-3 rounded-xl border border-[#d4af37]/40 bg-[#f9f6f0] px-4 py-3 text-[13px] leading-relaxed text-slate-700"
      style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-[#b8860b]" aria-hidden="true" />
      <span>
        <span className="font-semibold text-slate-900">Sample cruise.</span>{" "}
        This illustrative voyage shows how Cruise Command works. The dates and ports are examples, not a bookable sailing.
      </span>
    </div>
  );
};

export default SampleVoyageBanner;
